import { PTState } from '../types';

export const ptRates: PTState[] = [
  {
    id: 'tamil_nadu',
    name: 'Tamil Nadu',
    slabs: [
      { min: 0, max: 21000, rate: 0 },
      { min: 21001, max: 30000, rate: 100 },
      { min: 30001, max: 45000, rate: 200 },
      { min: 45001, max: 60000, rate: 200 },
      { min: 60001, max: 75000, rate: 200 },
      { min: 75001, max: null, rate: 200 }
    ],
    annualLimit: 2500,
    yearlyRate: 2500,
    monthlyRate: 208.33
  },
  {
    id: 'karnataka',
    name: 'Karnataka',
    slabs: [
      { min: 0, max: 15000, rate: 0 },
      { min: 15001, max: null, rate: 200 }
    ],
    annualLimit: 2400,
    yearlyRate: 2400,
    monthlyRate: 200
  },
  {
    id: 'maharashtra',
    name: 'Maharashtra',
    slabs: [
      { min: 0, max: 7500, rate: 0 },
      { min: 7501, max: 10000, rate: 175 },
      { min: 10001, max: null, rate: 200 }
    ],
    annualLimit: 2500,
    yearlyRate: 2500,
    monthlyRate: 200,
    specialRules: {
      gender: 'female',
      monthlyRates: {
        2: 300 // February has different rate
      }
    }
  },
  {
    id: 'telangana',
    name: 'Telangana',
    slabs: [
      { min: 0, max: 15000, rate: 0 },
      { min: 15001, max: 20000, rate: 150 },
      { min: 20001, max: null, rate: 200 }
    ],
    annualLimit: 2500,
    yearlyRate: 2500,
    monthlyRate: 200
  },
  {
    id: 'west_bengal',
    name: 'West Bengal',
    slabs: [
      { min: 0, max: 10000, rate: 0 },
      { min: 10001, max: 15000, rate: 110 },
      { min: 15001, max: 25000, rate: 130 },
      { min: 25001, max: 40000, rate: 150 },
      { min: 40001, max: null, rate: 200 }
    ],
    annualLimit: 2500,
    yearlyRate: 2500,
    monthlyRate: 200
  },
  {
    id: 'custom',
    name: 'Custom',
    slabs: [{ min: 0, max: null, rate: 200 }],
    monthlyRate: 200,
    annualLimit: 2400,
    yearlyRate: 2400
  }
];